export default "__VITE_ASSET__BqEBJ$Eb__"